import React, { useState, useEffect, useContext } from 'react';
import { useHistory } from "react-router-dom";
import QRCode from 'react-qr-code';
import { SuccessContent, Total } from './style';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { FaCopy, FaCheckCircle } from 'react-icons/fa';
import { useDate } from "../../../hooks/useDate";
import { toast } from "react-toastify";
import { AuthContext } from '../../../context/Auth/AuthContext';
import { SocketContext } from '../../../context/Socket/SocketContext';

function CheckoutSuccess(props) {

  const { pix } = props;
  const socketManager = useContext(SocketContext);
  const activeGateway = pix?.activePaymentGateway || 'none';
  const mpPixString = pix?.mpPixString;
  const mpBankSlipUrl = pix?.mpBankSlipUrl || pix?.mpTicketUrl;
  const pixString =
    activeGateway === 'mercadopago'
      ? mpPixString || pix?.qrcode?.qrcode || ''
      : pix?.qrcode?.qrcode || pix?.asaasPixString || '';
  const stripeURL = pix?.stripeURL;
  const asaasURL = pix?.asaasURL;
  const mercadopagoURL = pix?.mercadopagoURL;
  const asaasBarcode = pix?.asaasBarcode;
  const asaasBankSlipUrl = pix?.asaasBankSlipUrl;
  const valorext = pix?.valorext;
  const [copied, setCopied] = useState(false);
  const [copiedBarcode, setCopiedBarcode] = useState(false);
  const history = useHistory();

  const { dateToClient } = useDate();
  const { user, socket } = useContext(AuthContext);

  const companyId = user.companyId;

  useEffect(() => {
    const onCompanyPayment = (data) => {
      if (data.action === "CONCLUIDA") {
        toast.success(`Sua licença foi renovada até ${dateToClient(data.company.dueDate)}!`);
        setTimeout(() => {
          history.push("/");
        }, 4000);
      }
    }
    socket.on(`company-${companyId}-payment`, onCompanyPayment);
    
    return () => {
      socket.disconnect();
    }
  }, [history, dateToClient, socketManager, companyId, socket]);

  const handleCopyQR = () => {
    setTimeout(() => {
      setCopied(false);
    }, 1 * 1000);
    setCopied(true);
  };

  const handleCopyBarcode = () => {
    setTimeout(() => {
      setCopiedBarcode(false);
    }, 1 * 1000);
    setCopiedBarcode(true);
  };

  return (
    <React.Fragment>
      <Total>
        <p><span>TOTAL</span></p>
        <strong>R$ {valorext.toLocaleString('pt-br', { minimumFractionDigits: 2 })}</strong>
      </Total>

	

    <SuccessContent>
  
  	{pixString && (
    <>
  
    <QRCode value={pixString} />
    <CopyToClipboard text={pixString} onCopy={handleCopyQR}>
      <button className="copy-button" type="button">
        {copied ? (
          <>
            <span>Copiado</span>
            <FaCheckCircle size={18} />
          </>
        ) : (
          <>
            <span>Copiar código QR PIX</span>
            <FaCopy size={18} />
          </>
        )}
      </button>
    </CopyToClipboard>
    <span>
      {activeGateway === 'mercadopago'
        ? 'Escaneie ou copie o PIX acima, baixe o boleto ou use o link Mercado Pago abaixo.'
        : 'Para finalizar, escaneie ou copie o PIX acima ou use o link Asaas abaixo para escolher boleto ou PIX.'}
    </span>
	<span><p> </p></span>
    
    </>
    )}

    {asaasBarcode && (
    <>
    <CopyToClipboard text={asaasBarcode} onCopy={handleCopyBarcode}>
      <button className="copy-button" type="button">
        {copiedBarcode ? (
          <>
            <span>Linha digitável copiada</span>
            <FaCheckCircle size={18} />
          </>
        ) : (
          <>
            <span>Copiar linha digitável do boleto</span>
            <FaCopy size={18} />
          </>
        )}
      </button>
    </CopyToClipboard>
    <span><p> </p></span>
    </>
    )}

    {activeGateway === 'asaas' && asaasBankSlipUrl && (
    <>
    <button
      onClick={() => window.open(asaasBankSlipUrl, '_blank')}
      type="button"
      style={{
        color: '#2e7d32',
        background: '#ffffff',
        border: '1px solid #2e7d32',
        padding: '6px 16px',
        fontSize: '18px',
        minWidth: '50%',
        boxSizing: 'border-box',
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        fontWeight: '500',
        lineHeight: '1.75',
        borderRadius: '4px',
        letterSpacing: '0.02857em',
        textTransform: 'uppercase',
        cursor: 'pointer',
      }}
    >
      Baixar boleto (PDF)
    </button>
    <span><p> </p></span>
    </>
    )}
    
    {activeGateway === 'stripe' && stripeURL && (
    <>
	<button onClick={() => window.open(stripeURL, '_blank')} type="button"

	style={{
    color: '#3c6afb',
    background: '#ffffff',
    border: '1px solid #3c6afb',
    padding: '6px 16px',
    fontSize: '18px',
    minWidth: '50%',
    boxSizing: 'border-box',
    transition: 'background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontWeight: '500',
    lineHeight: '1.75',
    borderRadius: '4px',
    letterSpacing: '0.02857em',
    textTransform: 'uppercase',
  	}}

	>
      Pagar com Cartão de Crédito
    </button>
	<span><p> </p></span>
    </>
    )}
    
    
    {activeGateway === 'mercadopago' && mpBankSlipUrl && (
    <>
    <button
      onClick={() => window.open(mpBankSlipUrl, '_blank')}
      type="button"
      style={{
        color: '#2e7d32',
        background: '#ffffff',
        border: '1px solid #2e7d32',
        padding: '6px 16px',
        fontSize: '18px',
        minWidth: '50%',
        boxSizing: 'border-box',
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        fontWeight: '500',
        lineHeight: '1.75',
        borderRadius: '4px',
        letterSpacing: '0.02857em',
        textTransform: 'uppercase',
        cursor: 'pointer',
      }}
    >
      Baixar boleto (PDF)
    </button>
    <span><p> </p></span>
    </>
    )}

    {activeGateway === 'mercadopago' && mercadopagoURL && (
    <>
    <button onClick={() => window.open(mercadopagoURL, '_blank')} type="button"

	style={{
    color: '#3c6afb',
    background: '#ffffff',
    border: '1px solid #3c6afb',
    padding: '6px 16px',
    fontSize: '18px',
    minWidth: '50%',
    boxSizing: 'border-box',
    transition: 'background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontWeight: '500',
    lineHeight: '1.75',
    borderRadius: '4px',
    letterSpacing: '0.02857em',
    textTransform: 'uppercase',
  	}}

	>
      Pagar no Mercado Pago
    </button>
	<span>
      No Mercado Pago você pode pagar com PIX, boleto ou cartão.
    </span>
	<span><p> </p></span>
    </>
    )}
    
    {activeGateway === 'asaas' && asaasURL && (
    <>
    <button onClick={() => window.open(asaasURL, '_blank')} type="button"

	style={{
    color: '#3c6afb',
    background: '#ffffff',
    border: '1px solid #3c6afb',
    padding: '6px 16px',
    fontSize: '18px',
    minWidth: '50%',
    boxSizing: 'border-box',
    transition: 'background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontWeight: '500',
    lineHeight: '1.75',
    borderRadius: '4px',
    letterSpacing: '0.02857em',
    textTransform: 'uppercase',
  	}}

	>
      Pagar no Asaas (boleto ou PIX)
    </button>
	<span>
      No Asaas você escolhe boleto ou PIX na hora do pagamento.
    </span>
	<span><p> </p></span>
    </>
    )}
    
    
</SuccessContent>
    </React.Fragment>
  );
}

export default CheckoutSuccess;
